export default __webpack_public_path__ + "static/media/ewm2.a6108d96.png";